import { render, staticRenderFns } from "./WindowView.vue?vue&type=template&id=4afde3b6&scoped=true&"
import script from "./WindowView.vue?vue&type=script&lang=js&"
export * from "./WindowView.vue?vue&type=script&lang=js&"
import style0 from "./WindowView.vue?vue&type=style&index=0&id=4afde3b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afde3b6",
  null
  
)

export default component.exports